import {Component} from 'react'

import BaseStrategy from '../BaseStrategy.js'
import ReconcileForm from './ReconcileForm.js'
import EditForm from './EditForm.js'
import actions from '../../../../redux/actions/ui/dataImport/strategies/supplierSKUStrategy.js'
import {getNounsFromValue} from '../../../../common/tokenizeOptions.js'

export default class SupplierSKUStrategy extends Component {
  render() {
    return (
      <BaseStrategy
        {...this.props}
        actions={actions}
        EditForm={EditForm}
        ReconcileForm={ReconcileForm}
      />
    )
  }
}

SupplierSKUStrategy.title = actions.title
const option = {
  value: 'manage_supplier_sku',
  display: 'Create/Update Supplier SKUs',
  category: 'suppliers',
  Component: SupplierSKUStrategy,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
SupplierSKUStrategy.option = option
